import {
  takeEvery,
  fork,
  put,
  all,
  call
} from 'redux-saga/effects';

// Login Redux States
import {
  EDIT_PROFILE,
  SET_PROFILE
} from './actionTypes';
import {
  profileError,
  setProfileSuccess
} from './actions';
import {
  getStoreCareCompanies,
  getStoreCompanies,
  getStoreEmployees,
  getStoreParts,
  getTaxpayerList
} from '../data/actions';
import {
  getAccessToken,
  getCompanyToken
} from '../../apis/auth';

import jwt from "jsonwebtoken";
import {
  getUsers
} from '../../apis/users';
import {
  geCompany
} from '../../apis/companies/companies';
import {
  get
} from 'lodash-es';
import {
  getEmployee
} from '../../apis/employee/employee';
import { COMPANY_TYPE } from '../../constants/COMPANY';
import { getMyRole } from '../../apis/role';
import { getManagerPermissions } from '../../apis/admin/roles';
import { isManagingType } from '../../utils/auth';
// import { logoutUser } from '../actions';

function* editProfile({
  payload: {
    user
  }
}) {
  try { } catch (error) {
    yield put(profileError(error));
  }
}



function* setProfile() {
  try {
    const accessToken = getAccessToken();
    const decoded = jwt.decode(accessToken);
    const {
      userIdx
    } = decoded;
    const response = yield call(getUsers, userIdx);
    const user = get(response, "data.user");

    const companyToken = getCompanyToken();
    if (companyToken && user) {
      const companyInfo = jwt.decode(companyToken);
      // 로그인 정보가 있는경우

      // 유저 companies 저장
      yield put(getStoreCompanies());


      // 직원 정보상세 
      let employee = yield call(getEmployee, companyInfo.employeeIdx);

      if (!employee || !employee.name) {
        const myPosition = COMPANY_TYPE.find(t => t.value === companyInfo.type);
        employee = {
          ...(employee || {}),
          name: myPosition.label
        };
        // 매니저의 경우 관리회사 및 관리 수임처 불러오기(불러올 수 있는 최대 수임처로 불러오기)
        yield put(getStoreCareCompanies());
      }

      let company = {};

      try {
        // 직원의 회사정보상세 
        const myCompany = yield call(geCompany, companyInfo.companyIdx);
        company = get(myCompany, "data.company");
        // trial 체크
        company.isTrial =
          (company.type === 1 && !company.taxCompanyIdx) ||
          (company.taxCompanyIdx && company.isTaxCompanyPause);

        company.isFree = 2 > companyInfo.type && company.membership?.level === "free";
      } catch (error) {
        console.error(error);
      }
      let role = {};
      let managerRole = {};
      let permissions = [];
      try {
        let myRole;
        let managerRoleData;

        if (isManagingType() && !employee.idx) {
          myRole = yield call(getManagerPermissions);
          managerRoleData = yield call(getMyRole);
        } else {
          myRole = yield call(getMyRole);
        }

        if (myRole.data && myRole.data.role) {
          role = myRole.data.role;
          if (role.permissions) {
            permissions = role.permissions;
          }
        }
        if (managerRoleData?.data?.role) {
          managerRole = managerRoleData.data.role;
        } else {
          managerRole = myRole.data.role;
        }

      } catch (error) {
        console.error(error);
      }

      if (company.state === 2) {
        window.location.href = '/logout';
      } else {
        // 유저 redux 저장
        yield put(setProfileSuccess({
          // 해당 회사 직원 정보 없어야 매니저
          isManaging: !employee.idx && isManagingType(),
          user: { ...user, ...companyInfo },
          employee: { ...employee, ...companyInfo },
          company: { ...company, ...companyInfo },
          role,
          permissions,
          managerRole,
        }));


        // 회사 직원 리스트 저장
        yield put(getStoreEmployees(
          { ...employee, ...companyInfo }
        ));
        // 조직 목록 저장
        yield put(getStoreParts());
      }
      if (companyInfo.type > 1) {
        yield put(getTaxpayerList());
      }

    } else {

      yield put(setProfileSuccess(null));
    }


  } catch (error) {
    console.error(error);
    yield put(profileError(error));
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile);
}

export function* watchSetProfile() {
  yield takeEvery(SET_PROFILE, setProfile);
}

function* ProfileSaga() {
  yield all([
    fork(watchProfile),
    fork(watchSetProfile),
  ]);
}

export default ProfileSaga;